import { gridSize } from '@atlaskit/theme/constants';
import { hexToRGBA } from '../../theme';
var margin = "0 ".concat(gridSize() / 2, "px");
export var containerCSS = function containerCSS(_ref) {
  var navigation = _ref.mode.navigation;
  return {
    alignItems: 'stretch',
    display: 'flex',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0,
    height: '100%',
    position: 'relative',
    '& > *': {
      flexShrink: 0,
      margin: margin
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      height: '100%',
      width: "".concat(gridSize() * 3, "px"),
      background: "linear-gradient(90deg, ".concat(hexToRGBA(navigation.backgroundColor, 0), " 0%, ").concat(hexToRGBA(navigation.backgroundColor, 0.7), " 50%, ").concat(hexToRGBA(navigation.backgroundColor, 1), " 100%)")
    }
  };
};
export var widthObserverContainerStyle = {
  flexShrink: 1,
  minWidth: '1px',
  margin: '0px',
  width: '100%',
  position: 'relative'
};
export var primaryButtonSkeletonCSS = {
  marginLeft: "".concat(gridSize() * 1.5, "px"),
  marginRight: "".concat(gridSize() * 1.5, "px")
};